import React from 'react';
import { Container } from 'react-bootstrap';
import { classNames } from '../../utils/class-names.js';

function getClassBySize(size) {
    switch(size){
        case "lg":
            return "py-4 py-sm-5";
        case "sm":
            return "py-2 py-sm-3";
        case "no":
            return "";
        default:
            return "py-3 py-sm-4";
    }
}
const LandingContainer = ({ id, className, bgClassName, pattern, variant, size, border, children })=>{
    const sizeClass = getClassBySize(size);
    const container = /*#__PURE__*/ React.createElement(Container, {
        className: classNames(sizeClass, className),
        style: {
            paddingBottom: "0.1px"
        }
    }, children);
    if (bgClassName || variant || pattern) {
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: classNames(variant && `text-bg-${variant}`, pattern && `bg-pattern-${pattern}`, border && `bg-border-${border}`, bgClassName)
        }, container);
    }
    return container;
};

export { LandingContainer };
//# sourceMappingURL=LandingContainer.js.map
